import { render, staticRenderFns } from "./tiaojia.vue?vue&type=template&id=8bf9ce98&scoped=true"
import script from "./tiaojia.vue?vue&type=script&lang=js"
export * from "./tiaojia.vue?vue&type=script&lang=js"
import style0 from "./tiaojia.vue?vue&type=style&index=0&id=8bf9ce98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf9ce98",
  null
  
)

export default component.exports